import { render, staticRenderFns } from "./NotesForm.vue?vue&type=template&id=b0147f70&scoped=true"
import script from "./NotesForm.vue?vue&type=script&lang=ts"
export * from "./NotesForm.vue?vue&type=script&lang=ts"
import style0 from "./NotesForm.vue?vue&type=style&index=0&id=b0147f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0147f70",
  null
  
)

export default component.exports